import { Luogo, SectionVM } from 'civil-status/view-models/step-form';
import { ID_ALTRO_STATO } from 'shell/components/shared/foreign-state-list';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { DESCRIPTION_ITALIAN_NATION, ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

export const transformerLuogo = (dataSection?: SectionVM): Luogo | undefined => {
  if (!dataSection) {
    return undefined;
  }

  const isOtherState = dataSection?.foreign?.state?.code === ID_ALTRO_STATO;
  const isOtherMunicipality =
    dataSection?.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

  return {
    key: {
      idLuogo: dataSection?.idLuogo || null,
    },
    idComune: dataSection?.italian?.municipality?.code?.toString()
      ? dataSection?.italian?.municipality?.code
      : undefined,
    nomeComune: isOtherMunicipality
      ? dataSection.italian?.otherMunicipality || undefined
      : dataSection?.italian?.municipality?.description,
    idProvincia: dataSection?.italian?.municipality?.idProvince || undefined,
    siglaProvincia: dataSection?.italian?.municipality?.province || undefined,
    idStato:
      dataSection?.isForeign && Boolean(dataSection?.foreign?.state?.code)
        ? dataSection?.foreign?.state?.code
          ? Number.parseInt(dataSection?.foreign?.state?.code, 10)
          : undefined
        : Boolean(dataSection?.italian?.municipality?.description)
        ? ID_ITALIAN_NATION
        : undefined,
    nomeStato:
      dataSection?.isForeign && Boolean(dataSection?.foreign?.state?.value)
        ? isOtherState
          ? dataSection?.foreign?.otherState || undefined
          : dataSection?.foreign?.state?.value
        : Boolean(dataSection?.italian?.municipality?.description)
        ? DESCRIPTION_ITALIAN_NATION
        : undefined,
    indirizzo: dataSection.address || undefined,
    luogo: dataSection.place || undefined,
    civico: dataSection.houseNumber || undefined,
    nomeComuneEstero: dataSection.foreign?.locationForeign || undefined,
    tipoSezione: dataSection?.typePersistence || undefined,
  };
};
